import type { SVGProps } from "react";

export function IconPurpleClock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28 14L28 28L42 28"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.0001 51.3334C40.8867 51.3334 51.3334 40.8867 51.3334 28C51.3334 15.1134 40.8867 4.66669 28.0001 4.66669C15.1134 4.66669 4.66675 15.1134 4.66675 28C4.66675 40.8867 15.1134 51.3334 28.0001 51.3334Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
